export const formatPrice = (value: number): string =>
    `€ ${isNaN(value) ? '...' : value.toFixed(2).replace('.', ',')}`
